// extracted by mini-css-extract-plugin
export var aggregationCell = "_2l-k";
export var aggregationRow = "_2l-j";
export var borderlessSpinnerContainer = "_2l-3";
export var closeIcon = "_2l-c";
export var columnHeaderSurface = "_2l-8";
export var columnHeaderSurfaceDragOverlay = "_2l-s";
export var columnHeaderSurfaceResizing = "_2l-p";
export var contextMenuAnchor = "_2l-1";
export var draggableColumnHeader = "_2l-q";
export var draggableColumnHeaderOverlay = "_2l-r";
export var expandIcon = "_2l-d";
export var expanded = "_2l-e";
export var filterDropdown = "_2l-f";
export var filterDropdownDivider = "_2l-a";
export var filterDropdownHeader = "_2l-i";
export var filterDropdownItem = "_2l-h";
export var filterDropdownModal = "_2l-g _2l-f";
export var filterItem = "_2l-9";
export var normalCellWithAdjustableBorder = "_2l-b";
export var pinButtonContainer = "_2l-l";
export var pinIcon = "_2l-m";
export var pinIconActive = "_2l-n";
export var spinner = "_2l-0";
export var spinnerContainer = "_2l-2";
export var tableContainer = "_2l-4";
export var tableContentDraggingColumns = "_2l-7";
export var tableContentInner = "_2l-6";
export var tableContentWrapper = "_2l-5";
export var viewButtonContainer = "_2l-o";